export default __webpack_public_path__ + "static/media/blog-details.24935499.png";